<template>
  <check-field ref="ETABLISSEMENT_USER_DISABLED"
               :value=value
               :contextId=contextId
               :editFieldInfo=editFieldInfo
               :disabled=readOnly
               :required=required
               :dataTable=dataTable
               :showMissing=showMissing
               @updated=setUpdated
               @context=setInitValue
               @error=setError>
  </check-field>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo'
  import CheckField from '@/framework/base/components/CheckField.vue'
  import CheckBase from '@/framework/base/components/CheckBase'
  import { RessourceGenControl } from '@/generated/ressources/generatedRessources';
  import { GenControl } from '@/generated/ressources/generatedRessources';

  export default defineComponent({
    extends: CheckBase,
    components: {
      CheckField
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.ETABLISSEMENT_USER_DISABLED); },
      editFieldInfo (): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 0;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live);
      }
    },
    methods: {
      touch (): void {
        // @ts-expect-error : generated method
        this.$refs.ETABLISSEMENT_USER_DISABLED.touch();
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.ETABLISSEMENT_USER_DISABLED.missing();
      }
    }
  })
</script>
